import axios from 'axios'
import { Response, Project } from '@/models'
import { IProjectService } from '@/services/IProjectService'

import ConfigConstants from '@/constants/Config.constants'
import { isEmpty } from 'lodash'

export default class ProjectService implements IProjectService {
  private endpointUrl: string

  private readonly options = {
    headers: {
      'Content-Type': ConfigConstants.CONTENT_TYPES.YT_V1,
      Accept: '*/*',
    },
  } as const

  constructor(endpointUrl: string) {
    this.endpointUrl = endpointUrl
  }

  public async getProjects(): Promise<Project[]> {
    return await axios
      .get<Response<Project[]>>(`${this.endpointUrl}/projects`, this.options)
      .then((response) => response.data.data)
  }

  public getProjectsOfOrganization(organizationIdOrSlug: string): Promise<Project[]> {
    return axios
      .get<
        Response<Project[]>
      >(`${this.endpointUrl}/organizations/${organizationIdOrSlug}/projects`, this.options)
      .then((response) => response.data.data)
  }

  public async getProjectById(projectId: number): Promise<Project | undefined> {
    return await axios
      .get<Response<Project>>(`${this.endpointUrl}/project/${projectId}`, this.options)
      .then((response) => response.data.data)
  }

  async createProjectInOrganization(
    project: Project,
    organizationIdOrSlug?: string,
  ): Promise<Project> {
    if (isEmpty(organizationIdOrSlug)) return this.createProject(project)
    else
      return axios
        .post(
          `${this.endpointUrl}/organizations/${organizationIdOrSlug}/project`,
          { data: project },
          this.options,
        )
        .then((response) => response.data.data)
  }
  async createProject(project: Project): Promise<Project> {
    return axios
      .post(`${this.endpointUrl}/project`, { data: project }, this.options)
      .then((response) => response.data.data)
  }
  async putProject(project: Project): Promise<Project> {
    return axios
      .put(`${this.endpointUrl}/project`, { data: project }, this.options)
      .then((response) => response.data.data)
  }

  async deleteProject(projectId: number): Promise<Project> {
    return axios
      .delete(`${this.endpointUrl}/project/${projectId}`, this.options)
      .then((response) => response.data.data)
  }

  async addProjectToFavorites(project: Project): Promise<Project> {
    return axios
      .post(`${this.endpointUrl}/favorite/${project.id}`, { projectId: project.id }, this.options)
      .then((response) => response.data.data)
  }

  async removeProjectFromFavorites(project: Project): Promise<Project> {
    return axios
      .delete(`${this.endpointUrl}/favorite/${project.id}`, this.options)
      .then((response) => response.data.data)
  }
}
